import { all, fork } from 'redux-saga/effects';
import { getLabPlanSaga, selectLabPlanSaga } from './get-lab-plan';
import { updateLabPlansLmsSettingsSaga } from './update-lab-plans-lms-settings';
export function* rootSaga() {
    yield all([fork(getLabPlanSaga), fork(selectLabPlanSaga), fork(updateLabPlansLmsSettingsSaga)]);
}
